import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { searchRatePlans } from "../../../../api";
import { COPY } from "../constants";

// Maximum page size for fetching all base rate plans in a single request.
// The implementation uses client-side filtering/search, so we fetch all data upfront.
// Properties with >1,000 base rate plans will be silently truncated by the API.
const MAX_RATE_PLANS_PAGE_SIZE = 1000;

const useBaseRatePlansFetcher = (propertyId) => {
  const [baseRatePlans, setBaseRatePlans] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBase = useCallback(async () => {
    if (!propertyId) return;
    setLoading(true);
    try {
      const response = await searchRatePlans({
        propertyId,
        search: "",
        page: 0,
        size: MAX_RATE_PLANS_PAGE_SIZE,
        clientType: "all",
      });
      const data = response?.data;
      if (data && Array.isArray(data.content)) {
        setBaseRatePlans(data.content);
      } else {
        toast.error(COPY.ERROR_LOAD_FAILED);
        setBaseRatePlans([]);
      }
    } catch (e) {
      globalThis.R7Insight?.error?.("Failed to load base rate plans", e);
      toast.error(COPY.ERROR_LOAD_FAILED);
      setBaseRatePlans([]);
    } finally {
      setLoading(false);
    }
  }, [propertyId]);

  // Fetch all data once when propertyId changes
  useEffect(() => {
    fetchBase();
  }, [fetchBase]);

  return { baseRatePlans, loading };
};

export default useBaseRatePlansFetcher;
